import { render, staticRenderFns } from "./NfCombo.vue?vue&type=template&id=77585996"
import script from "./NfCombo.vue?vue&type=script&lang=js"
export * from "./NfCombo.vue?vue&type=script&lang=js"
import style0 from "./nfCombo.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports